import { Controller } from "@hotwired/stimulus";

/**
 * Lookup Config Controller
 *
 * Manages the single lookup configuration UI on the data source form.
 * This defines how this data source can be looked up by FK fields on other sources.
 */
export default class extends Controller {
  static targets = [
    "hiddenField",
    "displayMethod",
    "searchExpression",
    "lookupScope",
    "valueAttribute",
    "linkable",
    "linkPathContainer",
    "linkPathHelper",
  ];

  static values = {
    initial: String,
  };

  connect() {
    // Parse initial config if provided
    if (this.initialValue) {
      try {
        this.config = JSON.parse(this.initialValue) || {};
      } catch (e) {
        console.warn("Failed to parse initial lookup config:", e);
        this.config = {};
      }
    } else {
      this.config = {};
    }
  }

  toggleLinkable() {
    if (!this.hasLinkableTarget || !this.hasLinkPathContainerTarget) return;

    const isLinkable = this.linkableTarget.checked;
    this.linkPathContainerTarget.classList.toggle("hidden", !isLinkable);
    this.updateConfig();
  }

  updateConfig() {
    const config = this.buildConfig();

    if (this.hasHiddenFieldTarget) {
      // Store as JSON or empty string if no config
      this.hiddenFieldTarget.value = Object.keys(config).length > 0 ? JSON.stringify(config) : "";
    }
  }

  buildConfig() {
    const config = {};

    const displayMethod = this.hasDisplayMethodTarget ? this.displayMethodTarget.value.trim() : "";
    if (displayMethod) {
      config.display_method = displayMethod;
    }

    const searchExpression = this.hasSearchExpressionTarget ? this.searchExpressionTarget.value.trim() : "";
    if (searchExpression) {
      config.search_expression = searchExpression;
    }

    const lookupScope = this.hasLookupScopeTarget ? this.lookupScopeTarget.value.trim() : "";
    if (lookupScope) {
      config.lookup_scope = lookupScope;
    }

    const valueAttribute = this.hasValueAttributeTarget ? this.valueAttributeTarget.value.trim() : "";
    if (valueAttribute && valueAttribute !== "id") {
      config.value_attribute = valueAttribute;
    }

    const isLinkable = this.hasLinkableTarget ? this.linkableTarget.checked : false;
    if (isLinkable) {
      config.linkable = true;
      const linkPathHelper = this.hasLinkPathHelperTarget ? this.linkPathHelperTarget.value.trim() : "";
      if (linkPathHelper) {
        config.link_path_helper = linkPathHelper;
      }
    }

    return config;
  }
}
